import { createContext } from '@lyearn/core/utils/context';

const QUIZ_BLOCK_CONTEXT = 'QUIZ_BLOCK_CONTEXT';

type IQuizBlockContext = {
  quizBlockId: string;
};

const [QuizContextProvider, useQuizContextProvider] =
  createContext<IQuizBlockContext>(QUIZ_BLOCK_CONTEXT);

export { QuizContextProvider, useQuizContextProvider };
